import KeyCodes from '@opsbase/lib-general/KeyCodes';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import TextField from '../TextField';
export const TextFieldWithStateAndBlur = (props) => {
    const { type, validator, value = '', onBlur, onKeyDown, alwaysBlur = false, ...otherProps } = props;
    const [currentValue, setCurrentValue] = useState((value || ''));
    const [isDirty, setIsDirty] = useState(false);
    const _doBlur = useMemo(() => v => {
        if (!onBlur)
            return;
        let valid = true;
        if (validator)
            try {
                validator.validate(v);
            }
            catch (_a) {
                valid = false;
            }
        setCurrentValue(value);
        if (valid)
            onBlur(v);
    }, [value, onBlur, validator]);
    const handleBlur = useCallback(() => {
        if (isDirty || alwaysBlur) {
            setIsDirty(false);
            if (type === 'number' && !!currentValue)
                _doBlur(parseFloat(currentValue));
            else
                _doBlur(currentValue);
        }
    }, [_doBlur, isDirty, alwaysBlur, type, currentValue]);
    const handleKeyDown = useCallback(e => {
        if (e.keyCode === KeyCodes.ENTER)
            handleBlur();
        if (!onKeyDown)
            return;
        onKeyDown(e, isDirty, currentValue);
    }, [handleBlur, onKeyDown, isDirty, currentValue]);
    const handleChange = useCallback(newValue => {
        setCurrentValue(newValue);
        setIsDirty(value !== newValue);
    }, [value]);
    useEffect(() => {
        setCurrentValue(value);
        setIsDirty(false);
    }, [value]);
    return (React.createElement(TextField, { type: type, value: currentValue, onChange: handleChange, onKeyDown: handleKeyDown, onBlur: handleBlur, ...otherProps }));
};
export default TextFieldWithStateAndBlur;
